export default "__VITE_ASSET__DELLlEcj__"